import { render, staticRenderFns } from "./InputLanguage.vue?vue&type=template&id=59d0c81b"
import script from "./InputLanguage.vue?vue&type=script&lang=js"
export * from "./InputLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports